import { FeatureNames } from '@swyft/ui';
import { useAppContext } from './appState';

export interface Config {
  ServerUrl: string;
  AuthClientId: string;
  AuthAuthority: string;
  TenantId: string;
  StripeKey: string;
}

export function getConfig(): Config {
  return {
    ServerUrl: process.env.REACT_APP_SERVER_URL as string,
    AuthClientId: process.env.REACT_APP_AUTH_CLIENT_ID as string,
    AuthAuthority: process.env.REACT_APP_AUTH_AUTHORITY as string,
    TenantId: process.env.REACT_APP_TENANT_ID as string,
    StripeKey: process.env.REACT_APP_STRIPE_KEY as string
  };
}

export const useFeature = (featureName: FeatureNames) => {
  const {
    state: { features }
  } = useAppContext();
  const feature = features.find((f) => f.name === featureName);
  if (!feature) {
    return {
      enabled: false,
      featureConfig: null
    };
  }
  const { enabled, featureConfig } = feature;
  return { enabled, featureConfig };
};
